import React from 'react';
import { Button, SIZE } from "baseui/button";
import PropTypes from 'prop-types';
import emailIcon from '../../../../../../assets/img/email-icon.svg';
import mailSentIcon from '../../../../../../assets/img/mail-sent-check.svg';
import { useSelector } from 'react-redux';
import { Spinner, SIZE as SpinnerSize } from 'baseui/spinner';
import './MainBody.scss';
import { getName } from '../../../../../util/getUserFullName';
import mobileBackground from '../../../../../../assets/img/jobhome/mobile_job_page_background.svg';
import useEmailSentSuccess from '../hooks/useEmailSentSuccess';

const MainBodyV2 = ({ mail_sent=false, sending_error=false, sendDesktopLoginMail, loading }) => {
    let name = getName();
    if (!name) {
        const state = useSelector((state) => ({ basic_info_page: state.basic_info_page }))
        const basic_info_page = state.basic_info_page;
        name = basic_info_page.firstName
    }

    useEmailSentSuccess(mail_sent, sending_error)

    return (
        <div className='turing-mobile-home-body'>
            <div className='turing-mobile-home-body__img-wrapper'><img src={mobileBackground} alt="" /></div>
            <h4 className='turing-mobile-home-body__heading'>Top remote software jobs are waiting for you!</h4>
            <div className='turing-mobile-home-body__info'>
                <div>
                    <p>
                        To continue your application, please complete the technical assessment. This is best done on a desktop for the optimal experience.
                    </p>
                    <p>
                        We can send you an email with a login link, so you can easily pick up where you left off on your desktop or laptop.
                    </p>
                </div>
                <div>
                    <Button
                        disabled={mail_sent}
                        onClick={sendDesktopLoginMail}
                        size={SIZE.compact}
                        colors={{ backgroundColor: '#2F6AE3', color: '#fff' }}
                        overrides={{
                        BaseButton: {
                            style: {
                                width: "100%",
                                gap: "8px"
                            }
                        }
                        }}
                    >
                        {loading && <Spinner $color='#fff' $size={SpinnerSize.small} />}
                        <img src={mail_sent ? mailSentIcon : emailIcon} alt="E" /> {mail_sent ? 'Login link sent to your email' : 'Email login link for desktop'} 
                    </Button>
                </div>
            </div>
        </div>
    )
}

MainBodyV2.propTypes = {
    mail_sent: PropTypes.bool,
    sending_error: PropTypes.bool,
    sendDesktopLoginMail: PropTypes.func,
    loading: PropTypes.bool
}

export default MainBodyV2